import React from "react";
import { motion } from "framer-motion";
import usePWAInstall from "../utils/usePWAInstall";
import "./PWAInstallBanner.css";
import { isIOS } from "../utils/device";

const PWAInstallBanner: React.FC = () => {
  const { isInstallable, promptInstall } = usePWAInstall();

   if (isIOS()) return null;
   
  if (!isInstallable) return null;

  return (
    <motion.div
      className="pwa-strip"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="pwa-strip-inner">
        <div className="pwa-left">
          <motion.span
            className="pwa-badge"
            animate={{ scale: [1, 1.05, 1] }}
            transition={{ repeat: Infinity, duration: 2 }}
          >
            New
          </motion.span>
          <span className="pwa-text">
            Install <strong>Gelwel App</strong> for faster, app-like experience
          </span>
        </div>

        <motion.button
          className="pwa-cta"
          whileHover={{ y: -2, boxShadow: "0 8px 24px rgba(255,214,0,0.4)" }}
          whileTap={{ scale: 0.96 }}
          onClick={promptInstall}
        >
          Install
        </motion.button>
      </div>
    </motion.div>
  );
};

export default PWAInstallBanner;
